import styles from "./LanguageTabs.module.scss";

export type Language = "en" | "az" | "de" | "es";

interface LanguageTabsProps {
  activeLanguage: Language;
  onLanguageChange: (lang: Language) => void;
}

const LanguageTabs = ({
  activeLanguage,
  onLanguageChange,
}: LanguageTabsProps) => {
  const languages: { code: Language; label: string }[] = [
    { code: "en", label: "EN" },
    { code: "az", label: "AZ" },
    { code: "de", label: "DE" },
    { code: "es", label: "ES" },
  ];

  return (
    <div className={styles.tabs}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          className={`${styles.tab} ${
            activeLanguage === lang.code ? styles.active : ""
          }`}
          onClick={() => onLanguageChange(lang.code)}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageTabs;
